module.exports = "mutation acceptRefi($refi: AcceptRefiInput!) {\n  acceptRefi(input: $refi) {\n    refi {\n      id\n    }\n  }\n}\n"